/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Section_UpgradeInputs */



/**
* | output |
* | --- |
* | "Upgrading & Downgrading" |
*
* @param {Faq_Section_UpgradeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const faq_section_upgrade = /** @type {((inputs?: Faq_Section_UpgradeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Section_UpgradeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Upgrade & Downgrade")
	return /** @type {LocalizedString} */ ("Upgrading & Downgrading")
});